import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getRebuildAPI } from "@rebuild/shared/api";
import type { EstimateChatSummary, EstimateChatUpdateBody } from "@rebuild/shared/models";
import { ESTIMATE_CHAT_KEYS } from "@/hooks/queries/estimate-chat";

const { estimateChatControllerUpdateChat } = getRebuildAPI();

type RenameOrArchiveChatVariables = { chatId: string; body: EstimateChatUpdateBody };

export function useRenameOrArchiveChatMutation(estimateId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ chatId, body }: RenameOrArchiveChatVariables) => estimateChatControllerUpdateChat(estimateId, chatId, body),
    onSuccess: (_data, { chatId, body }) => {
      const key = ESTIMATE_CHAT_KEYS.chats(estimateId);

      queryClient.setQueryData<EstimateChatSummary[]>(key, (chats) => {
        if (!chats) return chats;
        if (body.archived) return chats.filter((c) => c.chatId !== chatId);
        if (body.name !== undefined) return chats.map((c) => (c.chatId === chatId ? { ...c, name: body.name } : c));
        return chats;
      });
    },
    onError: (error) => {
      console.error("Rename or archive chat error:", error);
    },
  });
}
